/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=5662a45a"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__